import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const getGeolocation = (latitude: number, longitude: number) =>
  apiLoaderInstance(
    URL.GET_GEOLOCATION.replace(':latitude', String(latitude)).replace(
      ':longitude',
      String(longitude)
    )
  );
